import { render } from "./TF2detailData.vue?vue&type=template&id=21c199e3&scoped=true"
import script from "./TF2detailData.vue?vue&type=script&lang=js"
export * from "./TF2detailData.vue?vue&type=script&lang=js"

import "./TF2detailData.vue?vue&type=style&index=0&id=21c199e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21c199e3"]])

export default __exports__